import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function AdminDashboard() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleSignout = () => {
    logout();
    navigate('/signin');
  };

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>
      <div className="flex flex-col space-y-4">
        <button
          onClick={() => navigate('/admin/tiers')}
          className="block w-64 mx-auto bg-blue-500 text-white px-6 py-3 rounded-md text-base font-normal"
        >
          Update Tiers
        </button>
        <button
          onClick={() => navigate('/admin/prompts')}
          className="block w-64 mx-auto bg-blue-500 text-white px-6 py-3 rounded-md text-base font-normal"
        >
          Update Prompts
        </button>
        <button
          onClick={() => navigate('/admin/active-users')}
          className="block w-64 mx-auto bg-blue-500 text-white px-6 py-3 rounded-md text-base font-normal"
        >
          Active Users
        </button>
        <button
          onClick={() => navigate('/admin/vision-requeue')}
          className="block w-64 mx-auto bg-blue-500 text-white px-6 py-3 rounded-md text-base font-normal"
        >
          Vision Requeue
        </button>
        <button
          onClick={() => navigate('/estate-sales-pipeline')}
          className="block w-64 mx-auto bg-blue-500 text-white px-6 py-3 rounded-md text-base font-normal"
        >
          Estate Sales
        </button>
        <button
          onClick={handleSignout}
          className="block w-64 mx-auto bg-blue-500 text-white px-6 py-3 rounded-md text-base font-normal"
        >
          Signout
        </button>
      </div>
    </div>
  );
}

export default AdminDashboard;
